import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Sidebar from '../../Components/Sidebar/Sidebar';
import verificandoApp from '../../../FuncoesGerais/verificaApp';
import verificandoToken from '../../../FuncoesGerais/VerificarToken';
import {
  fetchChamadosAutomaticosTodos,
  createChamadoAutomatico,
  updateChamadoAutomatico,
  deleteChamadoAutomatico
} from '../../../api/chamadosAutomaticos';
import { fetchTiposChamadoTodos } from '../../../api/cadastroChamados';
import { ModalConfirm } from '../../Components/ModalSistema';
import CadastroFormDrawer from '../../Components/CadastroFormDrawer/CadastroFormDrawer';
import './chamadosAutomaticos.css';

function ChamadosAutomaticos() {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [id, setId] = useState('');
  const [nome, setNome] = useState('');
  const [descricaoSolucao, setDescricaoSolucao] = useState('');
  const [tipoChamadoId, setTipoChamadoId] = useState('');
  const [areaResolucao, setAreaResolucao] = useState('S');
  const [ordem, setOrdem] = useState(0);
  const [ativo, setAtivo] = useState(1);
  const [mensagem, setMensagem] = useState('');
  const [busca, setBusca] = useState('');
  const [filtroAtivo, setFiltroAtivo] = useState('todos');
  const [formDrawerOpen, setFormDrawerOpen] = useState(false);
  const [confirmExcluir, setConfirmExcluir] = useState({ show: false, itemId: null, itemNome: '' });

  const verificar = async () => {
    const resultado = await verificandoApp('ATENDENTE');
    if (!resultado) history.push('/');
  };

  const load = async () => {
    setLoading(true);
    verificandoToken();
    try {
      const [list, tiposList] = await Promise.all([
        fetchChamadosAutomaticosTodos(),
        fetchTiposChamadoTodos()
      ]);
      setData(Array.isArray(list) ? list : []);
      setTipos(Array.isArray(tiposList) ? tiposList : []);
    } catch (e) {
      setMensagem('Erro ao carregar lista');
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    verificar();
    load();
  }, []);

  const limparForm = () => {
    setId('');
    setNome('');
    setDescricaoSolucao('');
    setTipoChamadoId('');
    setAreaResolucao('S');
    setOrdem(0);
    setAtivo(1);
    setMensagem('');
  };

  const handleEdit = (item) => {
    setId(item.id);
    setNome(item.nome || '');
    setDescricaoSolucao(item.descricao_solucao || '');
    setTipoChamadoId(item.tipo_chamado_id != null ? String(item.tipo_chamado_id) : '');
    setAreaResolucao(item.area_resolucao === 'I' ? 'I' : 'S');
    setOrdem(item.ordem != null ? Number(item.ordem) : 0);
    setAtivo(item.ativo != null ? Number(item.ativo) : 1);
    setMensagem('');
    setFormDrawerOpen(true);
  };

  const salvar = async () => {
    const nomeTrim = (nome || '').trim();
    if (!nomeTrim) {
      setMensagem('Nome é obrigatório.');
      return;
    }
    setMensagem('');
    verificandoToken();
    try {
      const body = {
        nome: nomeTrim,
        descricao_solucao: descricaoSolucao || '',
        tipo_chamado_id: tipoChamadoId || null,
        area_resolucao: areaResolucao,
        ordem: Number(ordem) || 0,
        ativo: Number(ativo) ? 1 : 0
      };
      if (id) {
        await updateChamadoAutomatico(id, body);
      } else {
        await createChamadoAutomatico(body);
      }
      limparForm();
      setFormDrawerOpen(false);
      load();
    } catch (e) {
      setMensagem(e?.response?.data?.error || e?.response?.data?.message || 'Erro ao salvar.');
    }
  };

  const excluir = (itemId, itemNome) => {
    setConfirmExcluir({ show: true, itemId, itemNome });
  };

  const executarExcluir = async () => {
    const { itemId: itemIdToDelete } = confirmExcluir;
    setConfirmExcluir({ show: false, itemId: null, itemNome: '' });
    if (!itemIdToDelete) return;
    verificandoToken();
    try {
      await deleteChamadoAutomatico(itemIdToDelete);
      load();
      if (id === itemIdToDelete) {
        limparForm();
        setFormDrawerOpen(false);
      }
    } catch (e) {
      setMensagem(e?.response?.data?.error || e?.response?.data?.message || 'Erro ao excluir.');
    }
  };

  const porBusca = !busca.trim()
    ? data
    : data.filter((c) =>
        String(c.nome || '').toLowerCase().includes(busca.toLowerCase()) ||
        String(c.descricao_solucao || '').toLowerCase().includes(busca.toLowerCase())
      );
  const filtrado =
    filtroAtivo === 'todos'
      ? porBusca
      : porBusca.filter((c) => (filtroAtivo === 'ativo' ? c.ativo : !c.ativo));

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        <div className="container-fluid titulo cadastro-unificado">
          <div className="page-header">
            <h1>Chamados automáticos</h1>
            <div className="toolbar flex-wrap">
              <div className="input-group input-group-sm" style={{ maxWidth: 280 }}>
                <input
                  value={busca}
                  onChange={(e) => setBusca(e.target.value)}
                  type="text"
                  className="form-control"
                  placeholder="Pesquisar"
                />
              </div>
              <select
                value={filtroAtivo}
                onChange={(e) => setFiltroAtivo(e.target.value)}
                className="form-control form-control-sm"
                style={{ maxWidth: 140 }}
                title="Filtrar por status"
              >
                <option value="todos">Todos</option>
                <option value="ativo">Ativos</option>
                <option value="inativo">Inativos</option>
              </select>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={() => {
                  limparForm();
                  setFormDrawerOpen(true);
                }}
              >
                Novo
              </button>
            </div>
          </div>
          <CadastroFormDrawer
            open={formDrawerOpen}
            onClose={() => {
              limparForm();
              setFormDrawerOpen(false);
            }}
            title={id ? 'Editar chamado automático' : 'Novo chamado automático'}
          >
            <div className="cadastro-form-drawer-form">
              <div className="form-group">
                <label>Nome</label>
                <input
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  className="form-control form-control-sm"
                  placeholder="Ex.: Liberação licença ERP"
                />
              </div>
              <div className="form-group">
                <label>Descrição / Solução (texto do chamado ao criar)</label>
                <textarea
                  value={descricaoSolucao}
                  onChange={(e) => setDescricaoSolucao(e.target.value)}
                  className="form-control form-control-sm"
                  rows={3}
                  placeholder="Texto usado como descrição e solução ao abrir o chamado automaticamente"
                />
              </div>
              <div className="form-group">
                <label>Tipo de chamado</label>
                <select
                  value={tipoChamadoId}
                  onChange={(e) => setTipoChamadoId(e.target.value)}
                  className="form-control form-control-sm"
                >
                  <option value="">Primeiro tipo ativo (padrão)</option>
                  {(tipos || []).map((t) => (
                    <option key={t.id} value={t.id}>
                      {t.nome || `Tipo ${t.id}`}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Área resolução</label>
                <select
                  value={areaResolucao}
                  onChange={(e) => setAreaResolucao(e.target.value)}
                  className="form-control form-control-sm"
                >
                  <option value="S">S</option>
                  <option value="I">I</option>
                </select>
              </div>
              <div className="form-group">
                <label>Ordem</label>
                <input
                  type="number"
                  value={ordem}
                  onChange={(e) => setOrdem(e.target.value)}
                  className="form-control form-control-sm"
                />
              </div>
              <div className="form-group">
                <label>Ativo</label>
                <select
                  value={ativo}
                  onChange={(e) => setAtivo(e.target.value)}
                  className="form-control form-control-sm"
                >
                  <option value={1}>Sim</option>
                  <option value={0}>Não</option>
                </select>
              </div>
              {mensagem && (
                <div className="alert alert-danger py-2 mb-2">{mensagem}</div>
              )}
              <div className="cadastro-form-drawer-form__actions">
                <button
                  onClick={() => {
                    limparForm();
                    setFormDrawerOpen(false);
                  }}
                  type="button"
                  className="btn btn-secondary btn-sm"
                >
                  Cancelar
                </button>
                <button onClick={salvar} type="button" className="btn btn-primary btn-sm">
                  Salvar
                </button>
              </div>
            </div>
          </CadastroFormDrawer>
          <div className="lista-wrapper">
            {mensagem && !formDrawerOpen && (
              <div className="alert alert-warning py-2 mb-2">{mensagem}</div>
            )}
            {loading ? (
              <p className="text-muted">Carregando...</p>
            ) : (
              <table className="table table-modern align-middle">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome</th>
                    <th>Descrição / Solução</th>
                    <th>Tipo</th>
                    <th>Área</th>
                    <th>Ordem</th>
                    <th>Ativo</th>
                    <th width="120">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {filtrado.length === 0 && !loading && (
                    <tr>
                      <td colSpan="8" className="text-center text-muted">
                        Nenhum chamado automático cadastrado. Use &quot;Novo&quot; para criar modelos usados no botão Automático da listagem de chamados.
                      </td>
                    </tr>
                  )}
                  {filtrado.map((c) => (
                    <tr
                      key={c.id}
                      className="table-row-clickable"
                      onClick={() => handleEdit(c)}
                    >
                      <td>{c.id}</td>
                      <td>{c.nome}</td>
                      <td className="texto-truncado" title={c.descricao_solucao || ''}>
                        {(c.descricao_solucao || '').slice(0, 60)}
                        {(c.descricao_solucao || '').length > 60 ? '…' : ''}
                      </td>
                      <td>{c.tipo_nome || '-'}</td>
                      <td>{c.area_resolucao || 'S'}</td>
                      <td>{c.ordem != null ? c.ordem : '-'}</td>
                      <td>
                        <span
                          className={
                            c.ativo ? 'badge-pill badge-ativo' : 'badge-pill badge-inativo'
                          }
                        >
                          {c.ativo ? 'Sim' : 'Não'}
                        </span>
                      </td>
                      <td onClick={(e) => e.stopPropagation()}>
                        <button
                          type="button"
                          className="btn btn-secondary btn-sm me-1"
                          onClick={() => handleEdit(c)}
                          title="Editar"
                        >
                          <i className="fas fa-edit" />
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            excluir(c.id, c.nome);
                          }}
                          title="Excluir"
                        >
                          <i className="fas fa-trash" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          <ModalConfirm
            open={confirmExcluir.show}
            onClose={() =>
              setConfirmExcluir({ show: false, itemId: null, itemNome: '' })
            }
            title="Excluir chamado automático"
            message={`Excluir "${confirmExcluir.itemNome}"?`}
            confirmLabel="Sim, excluir"
            cancelLabel="Cancelar"
            onConfirm={executarExcluir}
            variant="danger"
          />
        </div>
      </main>
    </div>
  );
}

export default ChamadosAutomaticos;
